'use client';

import FeaturedMedia from 'molecules/FeaturedMedia';
import FeaturedText from 'molecules/FeaturedText';
import Layout2Up from 'molecules/Layout2Up';

import type { CalloutSwitchbackProps } from 'components/Switchbacks/CalloutSwitchback/config';
import type { FC } from 'react';

type ComponentCalloutSwitchbackProps = CalloutSwitchbackProps;

const CalloutSwitchback: FC<ComponentCalloutSwitchbackProps> = ({
  textPosition = 'left',
  featuredMedia,
  featuredText,
}) => {
  const left = textPosition === 'left' ? <FeaturedText {...featuredText} /> : <FeaturedMedia {...featuredMedia} />;
  const right = textPosition === 'right' ? <FeaturedText {...featuredText} /> : <FeaturedMedia {...featuredMedia} />;

  return <Layout2Up left={left} right={right} />;
};

export default CalloutSwitchback;
